export const TEACHER_LIST_TEXT = [
    'Notes available from {0} teacher',
    'Notes available from {0} teachers',
];

export const TEACHER_LIST_MENU_SAVE_NOTES = 'Save notes';
export const TEACHER_LIST_MENU_VIEW_PROFILE = 'View profile';
export const TEACHER_COPY_PHRASES_RESULT = '{copyCount} phrase(s) has been copied';
export const TEACHER_COPY_NOTHING_COPY = 'Nothing to copy';